import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentView } from 'entities/tour/models/document'

import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { Button } from 'shared/ui/button'

import common from '../../styles.module.scss'

interface Props {
  document: TourDocumentView
}

export const AddendumCard: FC<Props> = ({ document }) => {
  const { t } = useTranslation()

  if (!document.additionalDocumentUrl) return null

  return (
    <section className={common.card}>
      <div className={common.row}>
        <div>
          <h2 className="bold-16">{t('tourDetails.addendumTitle')}</h2>
          <p className={clsx(common.caption, 'regular-14')}>
            {t('tourDetails.addendumCaption')}
          </p>
        </div>
      </div>
      <Button
        variant="transparent"
        className={clsx(common.link, 'medium-14')}
        onClick={() =>
          previewPdfUrl(document.additionalDocumentUrl ?? undefined)
        }
      >
        {t('tourDetails.openContract')}
      </Button>
    </section>
  )
}
